import React from 'react';
import {Checkbox, Divider, FormControlLabel, FormGroup, Grid, RadioGroup, TextField, Typography} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor, {MODE_CREATE, MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import localStrings from "../../../localStrings";
import {useNavigate} from "react-router";
import {dashboardBaseRoute} from "../../../routes/dashboard";
import {not_found_path} from "../../../routes";
import {
    addDataChartImplementationToCache,
} from "../../../gql/chartImplementationGql";

import {
    addDataChartCategoryToCache,
    createChartCategoryMutation,
    getChartCategoryQuery,
    updateChartCategoryMutation
} from "../../../gql/chartCategoryGql";

export const getChartImplementation = async (chartCategoryId,
                                             modeEdit, navigate) => {
    if (modeEdit == MODE_CREATE) {
        return null;
    }
    if (!modeEdit || modeEdit == MODE_EDIT) {
        var res =
            await executeQueryUtil(getChartCategoryQuery(chartCategoryId ));
        if (!res.data?.getChartCategory) {
            navigate('/' + not_found_path);
            return;
        }
        return res;
    }
    return null;
}

export const saveForm = async (item, values, modeEdit, navigate, filter) => {
    let data;
    if (!modeEdit || modeEdit == MODE_EDIT) {
        data = {
            ...item,
            ...values,
        };
        await executeMutationUtil(updateChartCategoryMutation(data));
        // clearChartDataCache(brandId, "", item.id, getChartData(filter));
        // clearChartDataCacheByImplementationId(item.id, filter);

    }

    else if (modeEdit == MODE_CREATE){
        data = {...values};
        const created = await executeMutationUtil(createChartCategoryMutation(data));
        await addDataChartCategoryToCache([created.data?.addChartCategory]);
        if (navigate) {
            navigate("/" + dashboardBaseRoute + "/chartCategories/detail/" + created.data?.addChartCategory?.id);
        }
    }


    return data;
}
const ChartCategoryCreateUpdateForm = ({className, modeEdit}) => {
    // let {restaurantId} = useParams();
    let {chartCategoryId} = useParams();
    const config = require('../../../conf/config.json');
    const {
        currentBrand,
        currentEstablishment,
        filter
    } = useAuth();
    const navigate = useNavigate();

    const buildFormValues = (item) => {
        return {
            initialValues: {
                name: item.name || '',
            },
            validationSchema: {
                name: Yup.string().max(255).required(localStrings.check.fieldRequired),
            }
        };
    }



    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >
                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.name && errors.name}
                        label={localStrings.name}
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.name}
                    />
                </Grid>


            </Grid>
        );
    }




    return (

        <>

            {currentEstablishment() && currentBrand() &&
                <GeneralEditor getItemFunction={() =>
                    getChartImplementation(chartCategoryId, modeEdit, navigate)}
                               className={className}
                               buildFormValues={buildFormValues}
                               getCardContentForm={getCardContentForm}
                               saveForm={(item, values) => saveForm(item, values, modeEdit, navigate, filter)}
                               applyButton={modeEdit == MODE_CREATE ? localStrings.create : localStrings.update}
                               resetFormProp={modeEdit == MODE_CREATE}
                               messageSuccess={modeEdit == MODE_CREATE ?
                                   localStrings.notif.chartCategoryCreated : localStrings.notif.charCategoryUpdated}
                               titleForm={modeEdit == MODE_CREATE ? localStrings.createChartCategory : localStrings.updateChartCategory}
                               getPathToData={(result) => {
                                   return  result.data.getChartCategory;
                               }}
                />
            }
        </>
    )
};

export default ChartCategoryCreateUpdateForm;
